import * as React from 'react';

import {DUE_UNIT_DAYS_ID} from 'nutshell-core/date-time/delays';

import type {StepDueDateInput} from 'nutshell-graphql-types';

import {DUE_FROM_PRIOR_TASK_ID} from './due-date-constants';
import {DueDateInputs} from './due-date-input';
import {Checkbox} from './fields/checkbox';

import styles from './date-time-picker.module.css';

const DEFAULT_VALUE = {
    dueFrom: DUE_FROM_PRIOR_TASK_ID,
    dueUnit: DUE_UNIT_DAYS_ID,
    dueTimespan: 1,
} as const;

type Props = {
    dueDate: StepDueDateInput | null | undefined;
    disabled?: boolean;
    onDueDateChange: (arg1?: StepDueDateInput | null | undefined) => void;
};

export class DateTimePicker extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles.container}>
                <Checkbox
                    onChange={this.handleToggle}
                    label='Due date'
                    disabled={this.props.disabled}
                    checked={Boolean(this.props.dueDate)}
                />
                {this.props.dueDate ? (
                    <DueDateInputs
                        onDueDateChange={this.props.onDueDateChange}
                        dueDate={this.props.dueDate}
                    />
                ) : undefined}
            </div>
        );
    }

    handleToggle = () => {
        if (this.props.dueDate) {
            // Is we currently have a dueDate, set value to null
            this.props.onDueDateChange(null);
        } else {
            // Not currently active, so give a default value
            this.props.onDueDateChange(DEFAULT_VALUE);
        }
    };
}
